<template>
  <div>
    <form id="form1">
      <div class='h-dialogContainer'>
      <div class='row h-row-inputBox h-tableHeight210'>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-inputLit'><span class="h-red-code">* </span>{{$t('TS.interval')}}:</div>
          <div v-for='(filterType, index) in filterTypeList' :key='index' class='col-sm-3 nopadding'>
            <ejs-radiobutton ref='filterType' name='filterType' :label='filterType.label' :value='filterType.value' :checked='filterType.checked' :change='radioChange'></ejs-radiobutton>
          </div>
        </div>
        <div v-show='queryConditions.timeInterval == 2' >
          <div class='col-sm-6 h-col-inputBox'>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{$t('TS.starttime')}}:</div>
            <ejs-datepicker format='yyyy-MM-dd' v-model='queryConditions.beginTime' name="beginTime" :allowEdit="allowEdit" :locale="locale"></ejs-datepicker>
          </div>
          <div class='col-sm-6 h-col-inputBox'>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{$t('TS.endtime')}}:</div>
            <ejs-datepicker format='yyyy-MM-dd' v-model='queryConditions.endTime' name="endTime" :allowEdit="allowEdit" :locale="locale"></ejs-datepicker>
          </div>
        </div>
        <div v-show='queryConditions.timeInterval == 3' >
          <div class='col-sm-6 h-col-inputBox'>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{$t('TS.starttime')}}:</div>
            <ejs-datepicker format='yyyy-MM' start="Year" depth="Year" v-model='queryConditions.beginTime' name="beginTime" :allowEdit="allowEdit" :locale="locale"></ejs-datepicker>
          </div>
          <div class='col-sm-6 h-col-inputBox'>
            <div class='h-inputLit'><span class="h-red-code">* </span>{{$t('TS.endtime')}}:</div>
            <ejs-datepicker format='yyyy-MM' start="Year" depth="Year" v-model='queryConditions.endTime' name="endTime" :allowEdit="allowEdit" :locale="locale"></ejs-datepicker>
          </div>
        </div>
        <div class='col-sm-12 h-col-inputBox'>
          <div class='h-inputLit'><span class="h-red-code">* </span>{{$t('TS.numHeader')}}:</div>
          <ejs-textbox  name="num" :placeholder="waterMark" v-model="queryConditions.num" multiline="true"></ejs-textbox>
          <!--<ejs-textbox  cssClass='height-160' name="num" :placeholder="waterMark" v-model="queryConditions.num" multiline="true"></ejs-textbox>-->
        </div>
      </div>
      </div>
      <div class="h-borderBox height-280" style="border: 1px solid #BFC9CE;">
        <div class="h-borderBox-top" style="height: 40px; background-color: #e6f7ff;">
          <div style="padding-top: 10px;padding-left:5px">{{$t('TS.ts_neList')}}</div>
        </div>
        <NeList ref='neInfo' :neArr='netype' :select='neClick' name="selectNeTree"></NeList>
      </div>
    </form>
  </div>
</template>

<script>

import NeList from '../common/NeList';
import { EventBus } from '../../plugins/eventBus';
import { FormValidator } from '@syncfusion/ej2-vue-inputs';
export default {
  name: 'QueryDataDialog',
  components: {
    NeList
  },
  data() {
    return {
      waterMark: `${this.$t('TS.correctFormat')}: sip:991@***,sip:992@***,sip:993@***`,
      showClearButton: false,
      locale: localStorage.getItem('locale'),
      minDate: '',
      manDate: '',
      allowEdit: false,
      valueType: { type: Number, default: 2 },
      filterTypeList: [
        { label: this.$t('TS.timeDay'), value: '2', checked: true },
        { label: this.$t('TS.timeMonth'), value: '3', checked: false }
      ],
      queryConditions: {
        beginTime: "",
        endTime: "",
        neId: '',
        num: '',
        timeInterval: 2
      },
      formObj: '',
      netype: [
        16, // mcs_pf
        2111//wp
        // 28 // pcdr
      ],
      items: [
        { sizeVal: 2, sizeTxt: this.$t('TS.time1day') },
        { sizeVal: 3, sizeTxt: this.$t('TS.time1month') }
      ],
      fields: { text: 'sizeTxt', value: 'sizeVal' },
      popupHeight: 200,
      currentIndex: 0
    };
  },
  beforeMount() {
    let minDate = new Date();
    minDate.setMonth(0);
    minDate.setDate(1);
    this.minDate = minDate;
    let maxDate = new Date();
    maxDate.setMonth(11);
    maxDate.setDate(31);
    this.maxDate = maxDate;
  },
  methods: {
    radioChange(args) {
      this.queryConditions.beginTime = "";
      this.queryConditions.endTime = "";
      this.queryConditions.timeInterval = args.value;
    },
    nameChange(event) {
      if (event.value === '2') {
        this.valueType = 2;
      } else {

      }
    },
    neClick() {
      this.queryConditions.neId = this.$refs.neInfo.getNe().data.id;
    },
    getSearchCondition() {
      if (this.queryConditions.beginTime === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateIsNull') })
        return;
      }
      if (this.queryConditions.endTime === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.endDateIsNull') })
        return;
      }
      // this.queryConditions.neId = 2000;
      if (this.queryConditions.neId === '') {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.neIDIsNull') })
        return;
      }
      if (new Date(this.queryConditions.beginTime).getTime() > new Date(this.queryConditions.endTime).getTime()) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.startDateGreaterEndDate') })
        return;
      }
      if (!(/^([^,]+,){0,49}[^,]+$/.test(this.queryConditions.num.trim()))) {
        EventBus.$emit('toast', { type: 'warning', content: this.$t('TS.correctFormat') })
        return;
      }
      return this.queryConditions;
    }
  }
};
</script>

<style>
</style>
